// Types
import type { TTooltipPosition, TTooltipProps } from './Tooltip.type';

export const TOOLTIP_POSITIONS: TTooltipPosition[] = [
'bottom-center',
'bottom-left',
'bottom-right',
'left-bottom',
'left-center',
'left-top',
'right-bottom',
'right-center',
'right-top',
'top-center',
'top-left',
'top-right',
];
export const TOOLTIP_POSITION: { [key in TTooltipPosition]: key } = {
	['bottom-center']: 'bottom-center',
	['bottom-left']: 'bottom-left',
	['bottom-right']: 'bottom-right',
	['left-bottom']: 'left-bottom',
	['left-center']: 'left-center',
	['left-top']: 'left-top',
	['right-bottom']: 'right-bottom',
	['right-center']: 'right-center',
	['right-top']: 'right-top',
	['top-center']: 'top-center',
	['top-left']: 'top-left',
	['top-right']: 'top-right',
}

export const TOOLTIP_DEFAULT_PROPS: Omit<TTooltipProps, 'children'> = {
	content: 'Tooltip',
	position: TOOLTIP_POSITION['top-center'],
}
